<script setup lang="ts">
    import { useApp } from "@/stores/app";

    import { LucideBookOpenCheck } from "lucide-vue-next";

    import {
        DropdownMenu,
        DropdownMenuContent,
        DropdownMenuItem,
        DropdownMenuLabel,
        DropdownMenuSeparator,
        DropdownMenuShortcut,
        DropdownMenuTrigger,
    } from "@/components/shadcn/ui/dropdown-menu";

    import Button from "@/components/tellscale/primitives/Button.vue";

    const app = useApp();

    const { t } = useI18n();
</script>

<template>
    <DropdownMenu>
        <DropdownMenuTrigger as-child>
            <Button size="icon" variant="outline">
                <LucideBookOpenCheck/>
            </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end">
            <DropdownMenuLabel class="mr-10">{{ t('language.supported') }}</DropdownMenuLabel>

            <DropdownMenuSeparator/>

            <div class="space-y-1">
                <DropdownMenuItem
                    v-for="lang in app.supportedLocales"
                    :key="lang.code"
                    @click="app.setLocale(lang.code)"
                    :class="{ 'bg-accent': app.locale === lang.code }"
                >
                    <span>{{ lang.label }}</span>
                    <DropdownMenuShortcut>{{ lang.code }}</DropdownMenuShortcut>
                </DropdownMenuItem>
            </div>
        </DropdownMenuContent>
    </DropdownMenu>
</template>

<style scoped lang="scss">

</style>